import { signal } from "@preact/signals-react";

import type { HealthResponse } from "@/shared/api/api-client";

export const dataLoading = signal(false);
export const dataReady = signal(false);
export const dataError = signal<string | null>(null);
export const appHealth = signal<HealthResponse>({ status: "loading", version: "", build: "" });
